<template>
  <b-input
    v-model="input"
    :placeholder="placeholder"
    icon-right="close"
    :icon-right-clickable="!!input"
    :class="{'clearable': !!input}"
    @icon-right-click="clear"
    @input="changeByUser"
    @focus="selectAll"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      input: null
    }
  },
  watch: {
    value: {
      handler (value) {
        if (this.input !== this.convert(value)) {
          this.input = this.convert(value)
        }
      },
      immediate: true
    },
    input: {
      handler (value) {
        this.$nextTick(() => {
          this.input = this.convert(value)
          this.$emit('input', Number(this.convert(value)))
        })
      }
    }
  },
  methods: {
    changeByUser (value) {
      this.$emit('changeByUser', Number(this.convert(value)))
    },
    convert (value) {
      // console.log('value', value)
      const convert = value
        ? value
          .toString()
          .replace(/,/g, '.')
          .replace(/\./, '-')
          .replace(/\./g, '')
          .replace(/-/g, '.')
          .replace(/[^0-9.]/, '')
          .replace(/^(\d+.?\d{0,2})\d*$/, '$1')
        : null

      return convert || null
    },
    clear () {
      this.input = null
      this.changeByUser()
    },
    selectAll (e) {
      if (e.target) {
        e.target.select()
      }
    }
  }
}
</script>
